<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-math-log</v-icon>{{$t('version.link.link')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <LinkForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import LinkForm from '../../components/link/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'Link';
const routeAfterDel = 'ChangeLogUpdate';
const routeAfterDelId = 'changeLog';

export default {
  name: 'LinkUpdate',
  servicePrefix,
  routeAfterDel,
  routeAfterDelId,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    LinkForm
  },

  computed: {
    ...mapFields('link', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('link', ['find'])

  },

  methods: {
    ...mapActions('link', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
